'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAcUnit = function MdAcUnit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 18.4v3.2h-6.9l5.4 5.4-2.4 2.5-7.7-7.9h-3.4v3.4l7.9 7.7-2.5 2.4-5.4-5.4v6.9h-3.2v-6.9l-5.4 5.4-2.4-2.4 7.8-7.7v-3.4h-3.4l-7.7 7.9-2.4-2.5 5.4-5.4h-6.9v-3.2h6.9l-5.4-5.4 2.4-2.4 7.7 7.8h3.4v-3.4l-7.9-7.7 2.5-2.4 5.4 5.4v-6.9h3.2v6.9l5.4-5.4 2.5 2.4-7.9 7.7v3.4h3.4l7.7-7.9 2.4 2.5-5.4 5.4h6.9z' })
        )
    );
};

exports.default = MdAcUnit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/ac-unit.js
// module id = 2014
// module chunks = 0